<template>
    <div class="backoffice requests">
        <b-container fluid>
            <b-row>
                <b-col cols="10" offset="1">
                    <div class="requests--topbar">
                        <div class="requests--filters">
                            <div class="requests--filter">
                                <b-form-input 
                                    placeholder="P-ID"
                                    type="text" 
                                    size="sm"
                                    v-model="current_pid"
                                ></b-form-input>
                                <div class="requests--remove" v-if="current_pid !== ''"
                                    @click="() => {
                                        page = 1
                                        current_pid = ''
                                        delete filter.pid
                                        get_soldquotes_paginated_from_api()
                                    }"
                                ></div>
                                <b-button class="service-btn" variant="success" size="sm" 
                                            @click="() => {
                                                page = 1
                                                filter.pid = current_pid
                                                get_soldquotes_paginated_from_api()
                                            }" title="ricerca">
                                    <font-awesome-icon icon="search" />
                                </b-button>

                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_status !== '' ? current_status : 'stato richiesta'"
                                    :variant="(current_status == '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_status"
                                >
                                    <b-dropdown-item v-for="(status,index) in statuses" v-bind:key="'key_current_status_'+index">
                                        <div v-html="status"
                                            @click="() => 
                                                {
                                                    page = 1
                                                    current_status = status
                                                    filter.soldquote_status = status
                                                    get_soldquotes_paginated_from_api()
                                                }
                                            "
                                        ></div>
                                    </b-dropdown-item>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_status !== ''"
                                    @click="() => {
                                        page = 1
                                        current_status = ''
                                        delete filter.soldquote_status
                                        get_soldquotes_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_banconista_id !== '' ? banconiste.filter(function(b){ return b.banconiste_id == current_banconista_id })[0].display_name : 'agente'"
                                    :variant="(current_banconista_id === '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_banconista_id"
                                >
                                    <b-dropdown-item v-for="(banconista, index) in banconiste" v-bind:key="'key_current_banconista_id_' + index">
                                        <div v-html="banconista.display_name"
                                            @click="() => 
                                                {
                                                    page = 1
                                                    current_banconista_id = banconista.banconiste_id
                                                    filter.banconiste_id = banconista.banconiste_id
                                                    get_soldquotes_paginated_from_api()
                                                }
                                            "
                                        ></div>
                                    </b-dropdown-item>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_banconista_id !== ''"
                                    @click="() => {
                                        page = 1
                                        current_banconista_id = ''
                                        delete filter.banconiste_id
                                        get_soldquotes_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_confirm_code !== '' ? current_confirm_code : 'confirmcode'"
                                    :variant="(current_confirm_code == '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_confirm_code"
                                >
                                    <b-dropdown-form>
                                        <b-form-input type="text" v-model="current_confirm_code" size="sm">
                                        </b-form-input>
                                        <b-button size="sm" variant="success"
                                            @click="() => {
                                                page = 1
                                                filter.confirm_code = current_confirm_code
                                                get_soldquotes_paginated_from_api()
                                            }">
                                            invia
                                        </b-button>
                                    </b-dropdown-form>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_confirm_code !== ''"
                                    @click="() => {
                                        page = 1
                                        current_confirm_code = ''
                                        delete filter.confirm_code
                                        get_soldquotes_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_name_surname !== '' ? current_name_surname : 'nome cliente'"
                                    :variant="(current_name_surname == '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_name_surname"
                                >
                                    <b-dropdown-form>
                                        <b-form-input type="text" v-model="current_name_surname" size="sm">
                                        </b-form-input>
                                        <b-button size="sm" variant="success"
                                            @click="() => {
                                                page = 1
                                                filter.name_surname = current_name_surname
                                                get_soldquotes_paginated_from_api()
                                            }">
                                            invia
                                        </b-button>
                                    </b-dropdown-form>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_name_surname !== ''"
                                    @click="() => {
                                        page = 1
                                        current_name_surname = ''
                                        delete filter.name_surname
                                        get_soldquotes_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_email !== '' ? current_email : 'email cliente'"
                                    :variant="(current_email == '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_email"
                                >
                                    <b-dropdown-form>
                                        <b-form-input type="text" v-model="current_email" size="sm">
                                        </b-form-input>
                                        <b-button size="sm" variant="success"
                                            @click="() => {
                                                page = 1
                                                filter.email = current_email
                                                get_soldquotes_paginated_from_api()
                                            }">
                                            invia
                                        </b-button>
                                    </b-dropdown-form>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_email !== ''"
                                    @click="() => {
                                        page = 1
                                        current_email = ''
                                        delete filter.email
                                        get_soldquotes_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_quote_title !== '' ? current_quote_title : 'nome prodotto'"
                                    :variant="(current_quote_title == '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_quote_title"
                                >
                                    <b-dropdown-form>
                                        <b-form-input type="text" v-model="current_quote_title" size="sm">
                                        </b-form-input>
                                        <b-button size="sm" variant="success"
                                            @click="() => {
                                                page = 1
                                                filter.quote_title = current_quote_title
                                                get_soldquotes_paginated_from_api()
                                            }">
                                            invia
                                        </b-button>
                                    </b-dropdown-form>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_quote_title !== ''"
                                    @click="() => {
                                        page = 1
                                        current_quote_title = ''
                                        delete filter.quote_title
                                        get_soldquotes_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                        </div>
                        <div class="requests--filter">
                            <b-dropdown
                                :text="show_deleted_soldquotes_criteria.filter(function(o) { return o.slug == show_deleted_soldquotes })[0].friendly"
                                :variant="(show_deleted_soldquotes == 0)? 'secondary' : 'danger'"
                                size="sm"
                                ref="trashed"
                            >
                                <b-dropdown-item v-for="(order,index) in show_deleted_soldquotes_criteria" v-bind:key="'key_show_deleted_soldquotes_' + index">
                                    <div v-html="order.friendly"
                                        @click="() => {
                                            page = 1
                                            show_deleted_soldquotes = order.slug
                                            filter.trashed = order.slug
                                            get_soldquotes_paginated_from_api()
                                        }"
                                    >
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>


                        <div class="requests--filter">
                            <b-dropdown
                                :text="current_order_by !== '' ? order_criteria.filter(function(o) { return o.slug == current_order_by })[0].friendly  : 'ordina'"
                                :variant="(current_order_by == '')? 'secondary' : 'success'"
                                size="sm"
                                ref="sort"
                            >
                                <b-dropdown-item v-for="(order,index) in order_criteria" v-bind:key="'key_current_order_by_' + index">
                                    <div
                                        v-html="order.friendly"
                                        @click="() => {
                                            page = 1
                                            current_order_by = order.slug
                                            filter.sort = order.slug
                                            get_soldquotes_paginated_from_api()
                                        }"
                                    >
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <div class="requests--filter">
                          <select v-model="records_per_page" @change="() => {
                                            page = 1
                                            get_soldquotes_paginated_from_api()
                                        }">
                            <option v-for="(option, index) in records_per_page_options" :value="option" v-bind:key="'key_records_per_page_' + index">
                              {{ option }}
                            </option>
                          </select>
                        </div>
                        <!--
                        <div class="requests--filter">
                            <b-button size="sm" variant="success" @click="get_soldquotes_paginated_from_api">
                                carica
                            </b-button>
                        </div>-->
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <b-container fluid v-if="!loading">
            <div v-if="results.data.length">


                <table class="requests--table">
                  <tr>
                    <th :class="'requests--id th-sort ' + has_filter('soldquotes_id')" @click="sort_by('soldquotes_id')">P-ID</th>

                    <th :class="'requests--confirmcode th-sort ' + has_filter('confirm_code')" @click="sort_by('confirm_code')">confirm code</th>

                    <th :class="'requests--created th-sort ' + has_filter('created_at')" @click="sort_by('created_at')">data ordine</th>

                    <th :class="'requests--name_surname th-sort ' + has_filter('name_surname')" @click="sort_by('name_surname')">Nome cliente</th>
                    <th :class="'requests--email th-sort ' + has_filter('email')" @click="sort_by('email')">Email cliente</th>
                    <th :class="'requests--phone'">Tel. cliente</th>
                    <th :class="'requests--quote_title th-sort ' + has_filter('quote_title')" @click="sort_by('quote_title')">Nome prodotto</th>

                    <th :class="'requests--status th-sort ' + has_filter('soldquote_status')" @click="sort_by('soldquote_status')">status</th>

                    <th :class="'requests--agent ' + has_filter('banconista_display_name')" >agent</th>

                    <th :class="'requests--lastmod th-sort ' + has_filter('updated_at')" @click="sort_by('updated_at')">ultima modifica</th>


                    <th class="requests--buttons"></th>
                  </tr>
                  <tr v-for="soldquote in results.data" v-bind:key="'key_soldquotes_id_' + soldquote.soldquotes_id">
                    <td class="requests--id">
                      P-{{ soldquote.soldquotes_id }}
                      <!--<b-button size="sm" variant="light" v-b-modal="'modal-request-'+soldquote.soldquotes_id">
                        {{ soldquote.soldquotes_id }} <font-awesome-icon icon="eye" />
                      </b-button>
                      <b-modal :id="'modal-request-'+soldquote.soldquotes_id" title="Richiesta utente" size="lg">
                        <user-request :user_request="JSON.parse(soldquote.user_request)" :pax="{}"/>
                      </b-modal>-->
                    </td>

                    <td class="requests--confirmcode" v-html="soldquote.confirm_code"></td>

                    <td class="requests--created">
                      {{ soldquote.created_at | moment("DD-MM-YYYY HH:mm") }}
                    </td>

                    <td class="requests--name_surname" v-html="soldquote.name_surname"></td>
                    <td class="requests--email" v-html="soldquote.user_email"></td>
                    <td class="requests--phone" v-html="soldquote.user_phone"></td>
                    <td class="requests--quote_title" v-html="soldquote.quote_title"></td>

                    <td class="requests--status">
                      <b-badge :variant="get_request_status(soldquote.soldquote_status)" v-html="soldquote.soldquote_status"></b-badge>
                    </td>

                    <td class="requests--agent" v-html="soldquote.banconista_display_name"></td>

                    <td class="requests--lastmod">
                      <div v-if="soldquote.updated_at != soldquote.created_at">
                        {{soldquote.updated_at | moment("DD-MM-YYYY HH:mm") }}
                      </div>
                    </td>


                    <td class="requests--buttons">
                      <history v-if="history_enabled" :soldquotes_id="soldquote.soldquotes_id" />
                      <!--<request-messages :request_id="request.request_id" />-->
                      <div v-if="my_banconiste_id != soldquote.banconiste_id">
                          <b-button class="service-btn" size="sm" @click="self_assign_to_api(soldquote.soldquotes_id)"><font-awesome-icon icon="download" /></b-button>
                      </div>
                      <div v-else>
                        <div v-if="!show_deleted_soldquotes">

                          <b-button class="service-btn" size="sm" @click="complete_soldquote(soldquote.soldquotes_id)" v-if="soldquote.soldquote_status != 'booked'"><font-awesome-icon icon="pen" /></b-button>
                          <b-button class="service-btn" size="sm" @click="complete_soldquote(soldquote.soldquotes_id)" v-if="soldquote.soldquote_status == 'booked'"><font-awesome-icon icon="eye" /></b-button>

                          <b-button class="service-btn" variant="danger" size="sm" @click="trash_soldquote(soldquote.soldquotes_id)">
                                    <font-awesome-icon icon="trash" />
                          </b-button>
                      </div>
                      <div v-else>
                        <b-button class="service-btn" variant="success" size="sm" @click="restore_a_soldquote(soldquote.soldquotes_id)" title="ripristina">
                            <font-awesome-icon icon="retweet" />
                        </b-button>
                      </div>
                          <!--<b-button class="service-btn" size="sm" @click="self_unassign_soldquote(soldquote.soldquotes_id)">libera</b-button>-->
                      </div>
                    </td>
                  </tr>
                </table>

                <b-row>
                    <b-col cols="10" offset="1">
                        <pagination
                            :data="results"
                            @pagination-change-page="(page) => {
                                this.page = page
                                this.get_soldquotes_paginated_from_api()
                            }"
                        >
                            <template #prev-nav>
                                <strong>&lt;</strong>
                            </template>
                            <template #next-nav>
                                <strong>&gt;</strong>
                            </template>
                        </pagination>
                    </b-col>
                </b-row>

            </div>
            <div v-else>
                <b-row>
                    <b-col cols="10" offset="1">
                        <p>nessuna prenotazione</p>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>    
</template>

<script>
    import Vue from 'vue'
    import LaravelVuePagination from 'laravel-vue-pagination';
    import {get_soldquotes_paginated, self_assign_soldquote, delete_soldquote, restore_soldquote} from '@/api'
    import History from '@/components/blocks/history'

    export default {
        name: 'soldquotes',
        components: {
          'pagination': LaravelVuePagination,
          'history': History,
        },
        data() {
            return {
                loading: true,
                results: {},
                page: 1,
                records_per_page: 25,
                records_per_page_options: [10, 25, 50, 100],
                filter: {
                    //request_status: "assigned"
                    'sort': 'updated_at.desc'
                },
                current_pid: '',
                current_status: '',
                current_quote_title: '',
                current_confirm_code: '',
                current_banconista_id: '',
                current_name_surname: '',
                current_email: '',
                statuses: [
                    //'all',
                    //'created',
                    'open',
                    'assigned',
                    'working',
                    //'inReview',
                    //'accepted',
                    //'declined',
                    //'rejected',
                    //'published',
                    'booked',
                ],
                current_order_by: 'updated_at.desc',
                order_criteria: [
                    {
                        friendly: 'Dal meno recente',
                        slug: 'created_at.asc',
                    },
                    {
                        friendly: 'Dal più recente',
                        slug: 'created_at.desc',
                    },
                    {
                      friendly: 'Modifiche recenti',
                      slug: 'updated_at.desc',
                    },

                ],
                show_deleted_soldquotes: 0,
                show_deleted_soldquotes_criteria: [
                    {
                        friendly: 'Prenotazioni cestinate',
                        slug: 1,
                    },
                    {
                        friendly: 'Prenotazioni attive',
                        slug: 0,
                    },
                ],
                banconiste: [
                    {banconiste_id: Vue.prototype.$config.user.profile.id, display_name: 'MIE'},
                    {banconiste_id: 0, display_name: 'NON ASSEGNATE'},
                    ...Vue.prototype.$config.banconiste
                ],
                my_banconiste_id: Vue.prototype.$config.user.profile.id,
                history_enabled: (Vue.prototype.$config.config.history_enabled)? true : false,
            }
        },
        computed: {
        },
        created()
        {
            this.get_soldquotes_paginated = get_soldquotes_paginated
        },
        mounted() {
            this.get_soldquotes_paginated_from_api()
        },
        methods:{
            get_soldquotes_paginated_from_api()
            {
                this.loading = true
                get_soldquotes_paginated({
                    page: this.page,
                    records_per_page:this.records_per_page,
                    filter: this.filter,
                    sort: this.sort,
                })
                    .then((data) => {
                        this.results = data.result
                        this.loading = false
                    })
            },

            // unassigned/assigned to others
            self_assign_to_api(soldquotes_id)
            {

              let _soldquotes_id = soldquotes_id

              self_assign_soldquote({ soldquotes_id: soldquotes_id})
                  .then(response => {
                    (response)
                    this.$router.push({
                      name: 'single-soldquote',
                      params: {
                        soldquotes_id: _soldquotes_id
                      }
                    })
                  })
            },

            complete_soldquote(soldquotes_id)
            {
              this.$router.push({
                name: 'single-soldquote',
                params: {
                  soldquotes_id: soldquotes_id
                }
              })
            },

            get_request_status(status)
            {
              let status_variant = 'info'

              if(status == 'open') status_variant = 'info'
              if(status == 'assigned') status_variant = 'warning'
              if(status == 'working') status_variant = 'warning'
              if(status == 'booked') status_variant = 'success'

              return status_variant
            },

            sort_by(slug)
            {
              if (this.filter.sort == slug+'.asc')
              {
                this.filter.sort = slug+'.desc'
              }
              else if (this.filter.sort == slug+'.desc')
              {
                this.filter.sort = slug+'.asc'
              }
              else
              {
                this.filter.sort = slug+'.asc'
              }
              this.get_soldquotes_paginated_from_api()
            },

            has_filter(slug)
            {
              if (this.filter.sort == slug+'.asc') return 'active asc'
              if (this.filter.sort == slug+'.desc') return 'active desc'
              return ''
            },

            trash_soldquote(soldquote_id) //lmbo973 - trash soldquote
            {

                if(!confirm('Vuoi eliminare la prenotazione P-'+soldquote_id+'?')) return
                Vue.$toast.info('elimino P-' + soldquote_id)
                delete_soldquote({ soldquotes_id: soldquote_id})
                    .then((success) => {
                        (success)
                        Vue.$toast.success('prenotazione cestinata')
                        this.$router.go()
                    })
            },

            restore_a_soldquote(soldquote_id) //lmbo973 - restore_soldquote
            {

                if(!confirm('Vuoi ripristinare la prenotazione P-'+soldquote_id+'?')) return
                Vue.$toast.info('ripristino P-' + soldquote_id)
                restore_soldquote({ soldquotes_id: soldquote_id})
                    .then((success) => {
                        (success)
                        Vue.$toast.success('prenotazione ripristinata')
                        this.$router.go()
                    })
            },

        },
    }
</script>

<style lang="scss">
.requests
{
  width:100%;
  margin-left: 0;
  .request-row
  {
    &:nth-child(odd)
    {
      background-color:rgba(200,200,200,0.2);
    }
    padding:0.75rem 0;
    display:flex;
    align-items: center;
  }
  .pagination
  {
    margin:60px auto;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  &--topbar
  {
    display:flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:20px;
  }
  &--filters
  {
    display:flex;
    align-items: center;
    flex:1;
  }
  &--filter
  {
    margin-right:1rem;
    display:flex;
    align-items: center;
    .dropdown-menu
    {
      overflow:hidden;
    }
    .b-dropdown-form
    {
      display:flex;
      input
      {
        min-width: 160px;
        border:0;
      }
      button
      {

      }
    }
  }
  &--remove
  {
    width:24px;
    height:24px;
    cursor:pointer;
    color:$info;
    position:relative;
    &:after
    {
      content:"x";
      position:absolute;
      top:50%;
      left:50%;
      transform:translateY(-50%) translateX(-50%);
    }
  }
  &--wrapper
  {
    max-width:100%;
    overflow-x:scroll;
  }
  &--table
  {
    width:100%;
    font-size:12px;
    .badge
    {
      font-size: 100%;
    }
    td,th
    {
      white-space: nowrap;
      padding:10px 16px;
    }
    th
    {
      text-align:left;
      padding:10px 16px;
    }
    .th-sort
    {
      cursor:pointer;
      transition:$transition-base;
      &:after
      {
        content: "";
        display:inline-block;
        margin-left:8px;
        width:10px;
        text-align: center;
      }
      &.active,
      &:hover
      {
        color:$cta;
      }
      &.active
      {
        &:after
        {
          content:">";
        }
        &.asc:after
        {
          transform:rotate(-90deg);
        }
        &.desc:after
        {
          transform:rotate(90deg);
        }
      }
    }
    tr:nth-child(odd):not(:nth-child(1))
    {
      background:rgba($gray-200,0.5);
    }
    tr:nth-child(1)
    {
      background:rgba($gray-200,1);
    }
  }
  &--id
  {
    .btn
    {
      display:flex;
      width:100%;
      align-items: center;
      justify-content: space-between;
      svg
      {
        margin-left:8px;
      }
    }
  }
  &--travel
  {
    text-align: center;
  }
  &--productcode
  {

  }
  &--confirmcode
  {

  }
  &--title
  {
    max-width: 20ch;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &--status
  {
  }
  &--agent
  {
  }
  &--created
  {

  }
  &--customer
  {

  }
  &--company
  {

  }
  &--budget
  {

  }
  &--availability
  {

  }
  &--lastmod
  {
  }
  &--buttons
  {
    display:flex;
    align-items: center;
    &>*
    {
      margin-right:12px;
    }
  }

}
</style>